import React from 'react';
import {
  TopPerformingAds,
  AdTypeAnalysis,
  CopyThemeAnalysis,
  CreativeBreakdown,
  CreativeAttributes,
  AudienceCreative,
  TimeTrends,
  PlatformPlacement
} from './dashboards';
import MediaLibrary from './MediaLibrary';
import GroupByAnalysis from './dashboards/GroupByAnalysis';

const MainDashboard = ({ dashboardData, filters, onFilterChange, activeTab }) => {
  // activeTab is now passed from parent

  const renderTabContent = () => {
    switch (activeTab) {
      case 'top-performing':
        return <TopPerformingAds filters={filters} onFilterChange={onFilterChange} />;
        
      case 'ad-type-analysis':
        return <AdTypeAnalysis filters={filters} onFilterChange={onFilterChange} />;
        
      case 'copy-theme-analysis':
        return <CopyThemeAnalysis filters={filters} />;
        
      case 'creative-breakdown':
        return <CreativeBreakdown dashboardData={dashboardData} filters={filters} onFilterChange={onFilterChange} />;
        
      case 'creative-attributes':
        return <CreativeAttributes dashboardData={dashboardData} filters={filters} onFilterChange={onFilterChange} />;
        
      case 'audience-creative':
        return <AudienceCreative dashboardData={dashboardData} filters={filters} onFilterChange={onFilterChange} />;
        
      case 'time-trends':
        return <TimeTrends dashboardData={dashboardData} filters={filters} onFilterChange={onFilterChange} />;
        
      case 'platform-placement':
        return <PlatformPlacement dashboardData={dashboardData} filters={filters} onFilterChange={onFilterChange} />;
        
      case 'media-library':
        return <MediaLibrary filters={filters} onFilterChange={onFilterChange} />;
        
      // Group By options - use generic GroupByAnalysis component
      case 'asset-id':
      case 'campaign-name':
      case 'concept':
      case 'value-proposition':
      case 'content-category':
      case 'talent-quantity':
      case 'talent-gender':
      case 'talent-age':
      case 'setting':
      case 'music-playing':
      case 'music-genre':
      case 'voiceover':
      case 'dominant-color':
      case 'video-length':
        return <GroupByAnalysis filters={filters} onFilterChange={onFilterChange} groupBy={activeTab} />;
        
      default:
        return (
          <div className="text-center py-12 text-gray-400">
            <p>Select a tab to view dashboard content</p>
          </div>
        );
    }
  };

  return (
    <div className="space-y-6">
      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default MainDashboard;
